import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

type BoardEmptyStateProps = {
  icon: ReactNode
  title: string
  hint: string
  className?: string
}

export function BoardEmptyState({ icon, title, hint, className }: BoardEmptyStateProps) {
  return (
    <div className={cn("flex h-full min-h-[50vh] flex-col items-center justify-center px-6 text-center", className)}>
      <div className="mb-4 rounded-lg border border-ui-border bg-ui-surface-sunken p-4 text-ui-text-muted [&_svg]:size-8">
        {icon}
      </div>
      <h2 className="text-lg font-semibold text-ui-text-primary">{title}</h2>
      <p className="mt-2 text-sm/6 text-balance whitespace-pre-line text-ui-text-secondary">{hint}</p>
    </div>
  )
}
